import { Suspense } from "react"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { AuthProvider } from "./auth/AuthProvider"
import AuthRoute from "./auth/AuthRoute"
import PageLayout from "./components/PageLayout"
import AppModalInitializer from "./contexts/AppModalInitializer"
import { LoadingProvider } from "./contexts/LoadingProvider"
import { ModalProvider } from "./contexts/ModalProvider"
import useWindowDimensions from "./hooks/useWIndowDimensions"
import routesConfig from "./routes-config"

const FileUploadApp = () => {
  const { height } = useWindowDimensions()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (_, { status }) => {
          if (status === 401) {
            return false
          } else {
            return 3
          }
        },
      },
    },
  })

  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ModalProvider>
              <AppModalInitializer />
              <LoadingProvider>
                <Routes>
                  {routesConfig.map((config, index) => {
                    return (
                      <Route
                        key={index}
                        path={config.path}
                        element={
                          config.protected ? (
                            <PageLayout height={height}>
                              <AuthRoute>
                                <config.Component />
                              </AuthRoute>
                            </PageLayout>
                          ) : (
                            <config.Component />
                          )
                        }
                      />
                    )
                  })}
                  <Route path="*" element={<Navigate replace to="/" />} />
                </Routes>
              </LoadingProvider>
            </ModalProvider>
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export default FileUploadApp
